// src/components/TalkToMyDocs.js
import React, { useState } from "react";

const TalkToMyDocs = ({ propertyId }) => {
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Ask about your documents — try: “When is my insurance renewal due?”" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const send = async () => {
    const q = input.trim();
    if (!q) return;
    setMessages((m) => [...m, { role: "user", content: q }]);
    setInput("");
    setLoading(true);
    try {
      const resp = await fetch(`/api/properties/${propertyId}/docs/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question: q }),
      });
      const data = await resp.json();
      if (data.error) throw new Error(data.error);
      const text =
        data.answer +
        (data.sources?.length
          ? `\n\nLikely sources:\n${data.sources.map((s) => `• ${s.name}`).join("\n")}`
          : "");
      setMessages((m) => [...m, { role: "assistant", content: text }]);
    } catch (e) {
      setMessages((m) => [...m, { role: "assistant", content: "Sorry — I couldn’t process that." }]);
    } finally {
      setLoading(false);
    }
  };

  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  return (
    <div className="bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 rounded-xl p-5 shadow-inner">
      <h3 className="font-semibold text-gray-800 mb-3">Talk to My Docs</h3>
      <div className="h-40 overflow-y-auto bg-white border border-gray-200 rounded-lg p-3 text-sm mb-3">
        {messages.map((m, i) => (
          <div key={i} className={`mb-2 ${m.role === "user" ? "text-gray-900" : "text-gray-700"}`}>
            <span className="font-semibold">{m.role === "user" ? "You: " : "HN: "}</span>
            <span className="whitespace-pre-wrap">{m.content}</span>
          </div>
        ))}
        {loading && <div className="text-gray-400 italic">Thinking…</div>}
      </div>
      <div className="flex gap-2">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={onKey}
          placeholder='e.g. "When is my home insurance renewal?"'
          className="flex-grow border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-red-400 focus:outline-none min-h-[44px]"
        />
        <button
          onClick={send}
          disabled={loading}
          className="bg-red-600 text-white px-4 rounded-lg hover:bg-red-700 disabled:opacity-50"
        >
          Ask
        </button>
      </div>
    </div>
  );
};

export default TalkToMyDocs;
